import { Typography } from 'antd';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import HeaderLabel from '../../../components/Form/HeaderLabel';
import AlumlyBreadCrumb, { PathT } from '../../../components/AlumlyBreadCrumb';
import AlumlyButton from '../../../components/AlumlyButton';
import { NotificationEnum } from '../../../enums/notification';
import { RouteNameEnum } from '../../../enums/routeName';
import { ServiceNameEnum } from '../../../enums/serviceName';
import useServices from '../../../hooks/useServices';
import { AxiosService } from '../../../utils/axiosService';
import NotificationInformation from '../components/NotificationInformation';
import usePermission from '../../../hooks/usePermission';
import { PermissionEnum } from '../../../enums/permission';

export interface NotificationDetailT {
  id: number;
  header: string;
  body: string;
  status: number;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
}

const NotificationDetail: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { checkPermission } = usePermission();
  const [notificationDetail, setNotificationDetail] = React.useState<NotificationDetailT>();

  const { service: getNotificationDetailService } = useServices(ServiceNameEnum.notification.detail);
  const { service: postCancelNotificationService } = useServices(ServiceNameEnum.notification.cancel);

  const getNotificationDetail = async (): Promise<void> => {
    const params = { id };
    const { data, error } = await getNotificationDetailService.get({ params });
    if (data) {
      setNotificationDetail(data);
    } else if (error) {
      const errorResponse = AxiosService.getErrorResponse(error);
      toast.error(errorResponse?.message, { toastId: 'allToast' });
    }
  };

  const onClickCancel = async (): Promise<void> => {
    const params = { id };
    const { error } = await postCancelNotificationService.post({}, { params });
    if (!error) {
      toast.success('Cancel Notification Success');
      navigate(RouteNameEnum.notification.index);
    } else {
      const errorResponse = AxiosService.getErrorResponse(error);
      if (errorResponse) {
        toast.error(errorResponse?.message, { toastId: 'allToast' });
      }
    }
  };

  const path: PathT[] = [
    {
      label: 'Notification',
      value: RouteNameEnum.notification.index,
    },
    {
      label: 'Notification details',
    },
  ];

  React.useEffect(() => {
    getNotificationDetail();
  }, []);
  return (
    <div>
      <AlumlyBreadCrumb path={path} />
      <Typography.Title level={4} style={{ fontWeight: 'bold', margin: 0 }}>Notification details</Typography.Title>
      {
        (
          notificationDetail?.status === NotificationEnum.status.pending
          && checkPermission([PermissionEnum.code.notificationCancel])
        )
        && (
          <div style={{
            marginTop: 32, display: 'flex', justifyContent: 'flex-end',
          }}
          >
            <AlumlyButton width={200} onClick={onClickCancel}>Cancel Notification</AlumlyButton>
          </div>
        )
      }
      <div style={{ marginTop: 32 }}>
        <HeaderLabel label="General info" />
        <div style={{ padding: 16, background: 'white' }}>
          <NotificationInformation title="Title" description={notificationDetail?.header || '-'} />
          <NotificationInformation title="Message" description={notificationDetail?.body || '-'} />
          <NotificationInformation title="Date created" description={notificationDetail?.createdAt || '-'} />
          <NotificationInformation title="Created by" description={notificationDetail?.createdBy || '-'} />
        </div>
      </div>
      <div style={{ marginTop: 16, textAlign: 'center' }}>
        <AlumlyButton width={100} onClick={() => navigate(RouteNameEnum.notification.index)}>Back</AlumlyButton>
      </div>
    </div>
  );
};

export default NotificationDetail;
